import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import FormPage from "./FormPage";
import ConfirmationPage from "./ConfirmationPage";
import PatientList from "./PatientList";
import PatientDetail from "./PatientDetail";
import ChangePassword from "./ChangePassword";
import EditPatient from "./EditPatient";
import Sig from "./sig";
import Sigcreate from "./sigcreate";
import FollowupConfirmationPage from "./FollowupConfirmationPage";
import FollowupFormPage from "./FollowupFormPage";
import FollowupPatientDetail from "./FollowupPatientDetail";

function App() {
  useEffect(() => {
    if (performance.navigation.type === 1) {
      sessionStorage.removeItem("token");
    }
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/form" element={<ConfirmationPage />} />
      <Route path="/form2" element={<FormPage />} />
      <Route path="/patients" element={<PatientList />} />
      <Route path="/patients/:id" element={<PatientDetail />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/patients/:id/edit" element={<EditPatient />} />
      <Route path="/sig" element={<Sig />} />
      <Route path="/sigcreate" element={<Sigcreate />} />
      <Route path="/followup" element={<FollowupConfirmationPage />} />
      <Route path="/followup2" element={<FollowupFormPage />} />
      <Route path="/followup-patients/:id" element={<FollowupPatientDetail />} />
    </Routes>
  );
}

export default App;
